import {
  EXTERNAL_LINKS,
  PRIVATE_ROUTES,
  REDIRECT_TO_URL_PATH_REGEX,
  ROUTES,
} from './constants'

export function logout(redirectTo = '/') {
  if (
    window.location.pathname.includes(ROUTES.logout) ||
    window.location.pathname.includes(ROUTES.login)
  ) {
    return
  }

  window.location.href = `${ROUTES.logout}?redirectTo=${redirectTo}`
}

export function isPrivateRoute(route: string) {
  return PRIVATE_ROUTES.some((privateRoute: string | RegExp) => {
    if (privateRoute instanceof RegExp) {
      return privateRoute.exec(route)
    }

    return privateRoute === route
  })
}

export function isValidRedirect(path: string) {
  const isSafeExternalLink = Object.values(EXTERNAL_LINKS).includes(path)
  console.log({ EXTERNAL_LINKS, path })

  const isPath = REDIRECT_TO_URL_PATH_REGEX.test(path)
  const isValidRoute = ![
    ROUTES.login,
    ROUTES.authLogin,
    ROUTES.signup,
    ROUTES.accessDenied,
    ROUTES.notFound,
  ].includes(path)

  return !!(path && (isSafeExternalLink || (isPath && isValidRoute)))
}
